export default __webpack_public_path__ + "static/media/group-211.f2e5c811.png";